module.exports = "<div class=\"lpview_timer timer\"></div>";